import __ from "src/utils/Translations";

export enum ContractType {
  INDEFINITE_TERM = "INDEFINITE_TERM",
  FIXED_TERM = "FIXED_TERM",
  TRIAL_PERIOD = "TRIAL_PERIOD",
  REPLACEMENT = "REPLACEMENT",
}

const getContractTypeLabels = (): Record<ContractType, string> => ({
  [ContractType.INDEFINITE_TERM]: __("Umowa na czas nieokreślony"),
  [ContractType.FIXED_TERM]: __("Umowa na czas określony"),
  [ContractType.TRIAL_PERIOD]: __("Umowa na okres próbny"),
  [ContractType.REPLACEMENT]: __("Umowa na zastępstwo"),
});

export const getContractTypeOptions = () =>
  Object.entries(getContractTypeLabels()).map(([value, label]) => ({
    value: value as ContractType,
    label,
  }));
